import * as Sentry from '@sentry/react';
import { MODE, MONITORING_CONNECTION_STRING, MONITORING_ENVIRONMENT, RELEASE_NAME } from '../config';

export enum Severity {
  error = 'error',
  warning = 'warning',
  debug = 'debug',
}

export function setupInstrumentation() {
  if (!MONITORING_CONNECTION_STRING) {
    return;
  }

  Sentry.init({
    dsn: MONITORING_CONNECTION_STRING,
    environment: MONITORING_ENVIRONMENT ? MONITORING_ENVIRONMENT : MODE,
    release: RELEASE_NAME,
    integrations: [Sentry.extraErrorDataIntegration()],
  });
}

export const trackMessage = (message: string, level: Severity, extra?: Record<string, unknown>) => {
  Sentry.captureMessage(message, {
    level,
    extra,
  });
};

export const trackException = (exception: unknown, level: Severity, extra?: Record<string, unknown>) => {
  Sentry.captureException(exception, {
    level,
    extra,
  });
};
